// extracted by mini-css-extract-plugin
export default {"boardContainer":"wordle_boardContainer__RnpFg","wrapper":"wordle_wrapper__xVDkX"};